import ioClient from 'socket.io-client';
import { BFF_HOST } from '../constants/settings.constants';
import { getToken } from './session.storage';

class SocketService {
  isConnected = false;

  setup() {
    if (this.isConnected) {
      return;
    }

    this.socket = ioClient(BFF_HOST[process.env.REACT_APP_SPO_ENV] || '', {
      withCredentials: true,
      extraHeaders: {
        Authorization: `Bearer ${getToken()}`
      }
    });
    this.isConnected = true;
  }

  subscribe(message, onMessage) {
    this.socket.on(message, onMessage);
  }

  disconnect() {
    this.socket.disconnect();
    this.socket = null;
    this.isConnected = false;
  }
}

export default new SocketService();
